import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  // baseURL: 'http://api.saemac.com.br/',
});

export default api;
